<template>
  <c-card
    padding
    :level="2"
    class="pin-hint"
  >
    <div class="_logo">
      <img src="/logo.svg">
    </div>
    <div class="_title">
      First, pin Notix to access later
    </div>
    <div class="_sub-title">
      Click the <c-icon
        type="puzzle"
        :style="{ display: 'inline' }"
      /> above to pin Notix.
    </div>
    <div class="_image">
      <img src="/illustrations/pin-hint.png">
    </div>
    <c-button
      stretch
      size="large"
      outlined
      @click="hide"
    >
      Dismiss
    </c-button>
  </c-card>
</template>
<script setup>
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CIcon from 'shared/components/CIcon.vue';

const emit = defineEmits(['hide']);
const hide = () => {
  emit('hide');
};
</script>

<style scoped lang="scss">
@import "shared/assets/scss/box-shadow";

  .pin-hint {
    position: fixed;
    right: 2rem;
    top: 2rem;

    ._logo {
      width: 10rem;

      img {
        width: 100%;
        height: auto;
      }
    }

    ._title {
      font-weight: 600;
      font-size: $font-size-8;
      margin: 3rem 0 1rem;
    }

    ._sub-title {
      font-weight: 400;
      font-size: $font-size-6;
      margin-bottom: 1rem;
    }

    ._image {
      @include box-shadow(1);

      border-radius: 10px;
      overflow: hidden;
      display: flex;
      margin-bottom: 2rem;
      width: 35rem;

      img {
        width: 100%;
        height: auto;
      }
    }
  }
</style>
